var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"frame"},[_c('Banner'),_c('BreadCrumb'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"process w1280"},[_c('div',[_c('div',{staticClass:"title animation srcospcur"},[_vm._v("门诊就医流程")]),_c('div',{staticClass:"pic animation srcospcur"},[_c('img',{attrs:{"src":"https://www.sclsnk.com/static/upload/image/20220822/1661126169973560.jpg","alt":""}})])])])
}]

export { render, staticRenderFns }